function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "4CF30470-22DC-4A9E-AABE-C803A7FCA06D");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with sketchtool.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Hamburger-Menu-NEW",
  transform: "translate(-396.000000, -40.000000)",
  fill: "#FFFFFF"
}, React.createElement("path", {
  d: "M424.368587,40.6575447 L424.342455,40.6314127 C423.492674,39.7816319 422.114907,39.7816319 421.265127,40.6314127 L410.5,51.3965393 L410.5,51.3965393 L399.734873,40.6314127 C398.885093,39.7816319 397.507326,39.7816319 396.657545,40.6314127 L396.631413,40.6575447 C395.781632,41.5073256 395.781632,42.8850926 396.631413,43.7348734 L407.396539,54.5 L407.396539,54.5 L396.631413,65.2651266 C395.781632,66.1149074 395.781632,67.4926744 396.631413,68.3424553 L396.657545,68.3685873 C397.507326,69.2183681 398.885093,69.2183681 399.734873,68.3685873 L410.5,57.6034607 L410.5,57.6034607 L421.265127,68.3685873 C422.114907,69.2183681 423.492674,69.2183681 424.342455,68.3685873 L424.368587,68.3424553 C425.218368,67.4926744 425.218368,66.1149074 424.368587,65.2651266 L413.603461,54.5 L413.603461,54.5 L424.368587,43.7348734 C425.218368,42.8850926 425.218368,41.5073256 424.368587,40.6575447 Z",
  id: "Mask",
  transform: "translate(410.500000, 54.500000) rotate(-270.000000) translate(-410.500000, -54.500000) "
})));

var SvgCloseWhite = function SvgCloseWhite(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: "29px",
    height: "29px",
    viewBox: "0 0 29 29",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgCloseWhite, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/close_white.053d158c.svg";
export { ForwardRef as ReactComponent };